import { useState, useEffect, useContext } from "react";
import { useParams } from "react-router";
import InquiryConcierge from "./../../../components/home/inquiryConcierge/InquiryConcierge";
import NotiBox from "./../../../components/common/notiBox/notiBox";
import { getRecommendHall } from "@src/api/recommend/recommend";
import dayjs from "dayjs";
import { getPartnerDetailUrl } from "@src/utils/route";
import { addLikeWeddinghall, removeLikeWeddinghall } from "@src/api/weddingHall/weddingHall";
import toast from "@src/utils/toast";
import { HOSTNAME, isExternalUrl } from "@src/utils";
import useDuplicateBooking from "@src/utils/hooks/useBookingState";
import { UserContext } from "@src/App";
import { DuplicateReservationModal } from "@src/components/weddingHall/home/HomeHallCard";

const Result = () => {
  const user = useContext(UserContext);
  const { uuid } = useParams<{ uuid: string }>(); // 추천홀 uuid
  const { isDuplicateBooking, setIsDuplicateBooking, getDuplicateReservation } =
    useDuplicateBooking();
  const [sentTsp, setSentTsp] = useState(null);
  const [hallList, setHallList] = useState<any[]>([]);
  const tagFinder = (arr: any[], t: number) => {
    let tag = arr.find((e) => e.type === t);
    return tag ? tag.name.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "xx";
  };
  useEffect(() => {
    getRecommendHall(uuid).then((res) => {
      const item = res.data.item;
      setHallList(item.partners);
      setSentTsp(item.sentTsp);
    });
  }, [uuid]);

  return (
    <div className="recommend-result-wrap">
      <div className="recommend-result-top">
        <h1 className="result-title">
          홀{" "}
          <img
            width={56}
            src="https://firebasestorage.googleapis.com/v0/b/weddingbookpro.appspot.com/o/common%2FimgTxt%403x.png?alt=media&token=a676a922-394e-4e02-bf7e-ac181d93fd7b"
            alt="weddinghall"
          />
          <br />
          추천리스트
        </h1>
        <p>
          {`고객님에게 추천드리는 웨딩홀 리스트입니다.
					마음에 드는 홀은 하트를 눌러 위시리스트에 담아보세요.`}
        </p>
      </div>
      <div style={{ marginTop: -80, paddingBottom: 32 }}>
        <ul className="hall-list-wrap">
          {hallList.map((hall, idx) => (
            <li>
              <div className="hall-thumb" style={{ backgroundImage: `url(${hall.coverUrl})` }}>
                <i
                  className={`icon large ${hall.isLike === 1 ? "icon-heart-filled" : "icon-heart-white"}`}
                  onClick={async (e) => {
                    e.stopPropagation();
                    e.preventDefault();

                    const updatedHallList = [...hallList];
                    updatedHallList[idx] = {
                      ...hall,
                      isLike: hall.isLike === 1 ? 0 : 1,
                    };
                    setHallList(updatedHallList);

                    try {
                      if (hall.isLike === 0) {
                        const res = await addLikeWeddinghall(hall.uuid, hall.name);
                        if (res === 200) {
                          toast.showSnackbar("위시리스트에 추가했습니다.", {
                            buttonText: "위시리스트 가기",
                            onClick: () => {
                              window.location.href = isExternalUrl(
                                `${HOSTNAME}/my-interest/like/partner?tab=2`,
                              );
                            },
                          });
                        } else {
                          throw new Error("위시리스트 추가 실패");
                        }
                      } else {
                        const res = await removeLikeWeddinghall(hall.uuid, hall.name);
                        if (res === 200) {
                          toast.showSnackbar("위시리스트에서 삭제했습니다.", { isShowClose: true });
                        } else {
                          throw new Error("위시리스트 삭제 실패");
                        }
                      }
                    } catch (error) {
                      const rolledBackHallList = [...hallList];
                      rolledBackHallList[idx] = {
                        ...hall,
                        isLike: hall.isLike,
                      };
                      setHallList(rolledBackHallList);
                      toast.showErrorSnackbar("요청 처리 중 문제가 발생했습니다.");
                    }
                  }}
                />
              </div>
              <div className="hall-info-wrap">
                <b className="hall-name">{hall.name}</b>
                <dl>
                  <div>
                    <dt>지역</dt>
                    {/* <dd>{`${tagFinder(hall.tags, 1)} ${tagFinder(hall.tags, 2)}`}</dd> */}
                    <dd>{hall.region}</dd>
                  </div>
                  <div>
                    <dt>식사 타입</dt>
                    <dd>{`${tagFinder(hall.tags, 15)}예식, ${tagFinder(hall.tags, 4)}`}</dd>
                  </div>
                  <div>
                    <dt>예식 시간</dt>
                    <dd>{`${tagFinder(hall.tags, 13)}분`}</dd>
                  </div>
                  <div>
                    {/* <dt>메모</dt> */}
                    <dd>{hall.memoContent}</dd>
                  </div>
                </dl>
                {/* 업체페이지 라우팅 */}
                <button
                  className="btn bold btn-full btn-medium btn-brown0"
                  onClick={async () =>
                    (window.location.href = await getPartnerDetailUrl(hall.uuid))
                  }
                >
                  자세히 보기
                </button>
                <button
                  className="btn bold btn-full btn-medium btn-brown500"
                  onClick={async () => {
                    await getDuplicateReservation(hall.uuid, user.me?.uuid, hall.partnerId, true);
                  }}
                >
                  방문 및 할인 문의
                </button>
              </div>
            </li>
          ))}
        </ul>
        <NotiBox>
          {sentTsp && (
            <p>
              - 본 보고서는 {dayjs(sentTsp).format("YYYY-MM-DD HH:mm:ss")}에 작성되었으며, 이후시간
              업체정보 및 가격이 달라질 수 있습니다.
            </p>
          )}
          <p>
            {`- 웨딩홀에 직접 문의 또는 연락 시 웨딩북 혜택 대상에서 제외되므로 [ 웨딩북 1:1 문의하기 ] 버튼을 눌러 문의주세요.`}
          </p>
        </NotiBox>
      </div>
      <InquiryConcierge page="recommend_hall_result" partnerTypeName="할인가, 잔여타임 등" />
      <DuplicateReservationModal
        isDuplicate={isDuplicateBooking}
        setIsDuplicate={setIsDuplicateBooking}
      />
    </div>
  );
};

export default Result;
